module.exports = __webpack_public_path__ + "media/images/iconArrowDown-6e21b725eb2809696cf1e1d9f9114019.png";